import { request, API_V1_PREFIX } from "./client";
import type { StudentData } from "./types";

export async function getStudents(token: string, schoolProfileId?: string): Promise<StudentData[]> {
  const query = schoolProfileId ? `?school_profile_id=${schoolProfileId}` : "";
  return request<StudentData[]>(`${API_V1_PREFIX}/students${query}`, { method: "GET" }, { token });
}

export async function createStudent(
  data: Omit<StudentData, "id">,
  token: string,
): Promise<StudentData> {
  return request<StudentData>(
    `${API_V1_PREFIX}/students`,
    {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(data),
    },
    { token },
  );
}

export async function deleteStudent(id: string, token: string): Promise<boolean> {
  return request<boolean>(`${API_V1_PREFIX}/students/${id}`, { method: "DELETE" }, { token });
}
